import * as React from 'react';
import NetInfo from '@react-native-community/netinfo';
import LoadingScreen from 'src/components/screens/LoadingScreen';
type withIsConnectedState = {
  isConnected: boolean;
};
export default function withIsConnected(Component: any) {
  class ComponentWithIsConnected extends React.Component<
    any,
    withIsConnectedState
  > {
    unsubscribe: any;

    constructor(props: any) {
      super(props);
      this.state = {
        isConnected: null,
      };
    }

    componentDidMount() {
      this.unsubscribe = NetInfo.addEventListener((state) => {
        if (this.state.isConnected !== state.isInternetReachable) {
          this.setState({isConnected: state.isInternetReachable ?? false});
        }
      });
    }

    componentWillUnmount() {
      if (this.unsubscribe) {
        this.unsubscribe();
      }
    }

    render() {
      const {isConnected} = this.state;
      if (isConnected === null) {
        return <LoadingScreen />;
      }
      return <Component isConnected={this.state.isConnected} {...this.props} />;
    }
  }

  return ComponentWithIsConnected;
}
